import { render, staticRenderFns } from "./CrudEducationDetails.vue?vue&type=template&id=d8a2f858&scoped=true"
import script from "./CrudEducationDetails.vue?vue&type=script&lang=ts"
export * from "./CrudEducationDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudEducationDetails.vue?vue&type=style&index=0&id=d8a2f858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2f858",
  null
  
)

export default component.exports